import * as React from "react";
const SvgFiRrGreaterThanEqual = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-greater-than-equal_svg__a)">
      <path
        fill="#062147"
        d="M21 23a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m-2.814-12.18L3.606 17.08a1 1 0 1 0 .79 1.837l14.58-6.262c1.249-.537 2.025-1.746 2.025-3.157 0-1.41-.776-2.62-2.025-3.157L4.395.082a1 1 0 1 0-.789 1.836l14.58 6.262c.601.258.814.851.814 1.32 0 .467-.214 1.06-.814 1.318z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-greater-than-equal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGreaterThanEqual;
